module.exports = __webpack_public_path__ + "img/ATL_2023Winter_SCADday_CG_011_JJ_v1.616f33ab.jpg";